import React, { FC } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { DealRoom } from 'models/DealRoom';
import ResolveImage from 'components/ResolveImage';
import { getImgUrl, RESIZED_WIDTH } from 'components/ResolveImage/utils';
import { getHasElementsInArray } from 'utils';
import usePastTime from 'hooks/usePastTime';
import { getRecentlyViewedDealRoute } from '../../utils';

import './RecentlyViewedDeals.styles.scss';

type RecentlyViewedDealsProps = {
  className?: string;
  deals: DealRoom[];
};

const RecentlyViewedDeals: FC<RecentlyViewedDealsProps> = (props) => {
  const { className, deals } = props;

  const { t } = useTranslation();

  const humanizeTime = usePastTime();

  const classes = classNames('recently-viewed-deals', className);

  if (!getHasElementsInArray(deals)) return null;

  return (
    <div className={classes}>
      <h3>{t('recentlyViewed')}</h3>

      <div className="recently-viewed-deals__list">
        {deals.map((deal) => {
          const { _id, listing, portfolioName, lastViewedAt } = deal;

          return (
            <Link
              key={_id}
              className="recently-viewed-deals__item"
              to={getRecentlyViewedDealRoute(deal)}
            >
              <div className="recently-viewed-deals__deal">
                <ResolveImage
                  src={getImgUrl(
                    listing?.gallery?.[0]?.url,
                    RESIZED_WIDTH[100],
                  )}
                />

                <span className="recently-viewed-deals__name">
                  {portfolioName}
                </span>
              </div>

              <span className="recently-viewed-deals__viewed">
                {lastViewedAt ? humanizeTime(lastViewedAt) : '-'}
              </span>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default RecentlyViewedDeals;
